<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    open-on-hover
    offset-x z-index="500">
    <template v-slot:activator="{ on }">
        <span v-on="on">
          <v-icon class="mx-2 pointer">
            {{ mdiHelpCircle }}
          </v-icon>
        </span>
    </template>
    <v-card>
      <v-card-title>{{ $vuetify.lang.t('$vuetify.map.mapHelp.title') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list dense>

          <v-list-item dense v-for="item in items" :key="item.title">
            <v-list-item-icon>
              <v-icon :color="item.color" large>{{ mdiMapMarker }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ $vuetify.lang.t(item.title) }}</v-list-item-content>
          </v-list-item>

        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiHelpCircle, mdiMapMarker } from '@mdi/js'

export default {
  name: 'mapHelp',
  data () {
    return {
      menu: false,
      mdiHelpCircle: mdiHelpCircle,
      mdiMapMarker: mdiMapMarker,
      items: [
        { title: '$vuetify.map.mapHelp.unknownState', color: 'black' },
        { title: '$vuetify.map.mapHelp.ignoredState', color: 'gray' },
        { title: '$vuetify.map.mapHelp.approvedState', color: 'green darken-3' },
        { title: '$vuetify.map.mapHelp.rejectedState', color: 'red' }
      ]
    }
  }
}
</script>

<style scoped>

</style>
